import { Action, Reducer } from 'redux';
import { delay } from 'redux-saga/effects';
import { fork, call, takeEvery, put, all, select } from 'redux-saga/effects';
import { createSelector } from 'reselect';

import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';

import Api from '../api';

import { actionCreators as layoutActionCreators } from '../reducers/Layout';
import { selectors as authSelectors } from '../reducers/Auth';

import { IRootState } from './index';
import { ODataOptions } from 'src/util/ODataBuilder';

export interface IStateState {
    isLoadingStates: boolean;
    states: PagedResultSet<State>;
}

const initialState: IStateState = {
    isLoadingStates: false,
    states: undefined,
};

export enum actionTypes {
    GET_STATES = '[state] GET_STATES',
    GET_STATES_SUCCESS = '[state] GET_STATES_SUCCESS',
}

export const actionCreators = {
    getStates: (options: ODataOptions) => {
        return { type: actionTypes.GET_STATES, payload: options };
    },
    getStatesSuccess: (states: PagedResultSet<State>) => {
        return { type: actionTypes.GET_STATES_SUCCESS, payload: states };
    },
};

const reducer: Reducer<IStateState> = (state: IStateState = initialState, action: Action): IStateState => {
    switch (action.type) {
        case actionTypes.GET_STATES:
            return {
                ...state,
                isLoadingStates: true,
            };
        case actionTypes.GET_STATES_SUCCESS:
            const getStatespayload = (action as { type: string; payload: PagedResultSet<State> }).payload;
            return {
                ...state,
                states: getStatespayload,
                isLoadingStates: false,
            };
        default:
            return state;
    }
};

export default reducer;

const stateSelector = (state: IRootState): PagedResultSet<State> => state.state.states;
const stateByIdSelector = (stateId: number) =>
    createSelector(stateSelector, (states) => {
        let s = undefined;
        if (states) {
            s = states.items.find((state: State) => state.id === stateId);
        }
        return s;
    });
export const selectors = {
    states: stateSelector,
    state: stateByIdSelector,
};

const sagas = {
    getStates: function* (action: { type: string; payload: ODataOptions }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const [result] = yield all([call(Api.State.getAll, action.payload, jwt), delay(200)]);
        yield put(actionCreators.getStatesSuccess(result));
    },
};

const watches = {
    getStates: function* () {
        yield takeEvery(actionTypes.GET_STATES, sagas.getStates);
    },
};

export function* saga() {
    yield fork(watches.getStates);
}



// WEBPACK FOOTER //
// ./src/reducers/State.ts